import React from "react";
import { useRef } from "react";
import { Box, useMediaQuery, useTheme, Fab, CircularProgress } from "@mui/material";
import GroupIcon from "../../../../static-materials/group.svg";
import useHelpWidget from "./useHelpWidget";
import { getHelpWidgetStyles } from "./HelpWidget.styles";
import { BUTTON_STATUSES, isVisibleButton } from "./useHelpWidget";


export function HelpWidget() {
  const containerRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const { isLoaded, buttonStatus, handleOpenChat } = useHelpWidget(containerRef);

  const styles = getHelpWidgetStyles(theme, isMobile);
  const showButton = isVisibleButton(buttonStatus);
  const isMinimized = buttonStatus === BUTTON_STATUSES.MINIMIZED;
  const isLoading = buttonStatus === BUTTON_STATUSES.LOADING;
  const isError = buttonStatus === BUTTON_STATUSES.ERROR;
  
  // Determine chat state for ARIA attributes
  const isChatOpen = buttonStatus === BUTTON_STATUSES.HIDDEN;
  const isChatMinimized = buttonStatus === BUTTON_STATUSES.MINIMIZED;
  

  return (
    <>
      {/* Hidden description for screen readers */}
      <Box
        id="help-widget-description"
        sx={{ 
          position: "absolute",
          left: "-10000px",
          width: "1px",
          height: "1px",
          overflow: "hidden"
        }}
        aria-live="polite"
        aria-atomic="true"
      >
        {isLoading && "Loading support chat..."}
        {isError && "Error loading support chat. Please try again."}
        {isChatMinimized && "Support chat minimized. Press to reopen."}
        {!isLoading && !isError && !isChatMinimized && "Help button. Press to open support chat."}
      </Box>

      <Box
        ref={containerRef}
        id="salesforce-help-widget-container"
        data-loaded={isLoaded}
        sx={styles.container}
      />

      {showButton && (
        <Fab
          size="medium"
          variant={isMobile ? "circular" : "extended"}
          role="button"
          aria-label={isMinimized ? "Open Chat" : "Help"}
          aria-describedby="help-widget-description"
          aria-expanded={isChatOpen}
          aria-pressed={isChatOpen || isChatMinimized}
          aria-live="polite"
          data-testid="help-widget-button"
          onClick={handleOpenChat}
          disabled={isLoading}
          sx={{
            ...styles.button,
            ...styles.fabButton,
            ...(isMinimized && styles.minimizedButton),
          }}
        >
          {isLoading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            <>
              <Box
                component="img"
                src={GroupIcon}
                alt={isMinimized ? "Open Chat" : "Help"}
                sx={isMobile ? { width: 24, height: 24 } : styles.icon}
              />
              {!isMobile && (
                <Box>
                  Help
                </Box>
              )}
            </>
          )}
        </Fab>
      )}
    </>
  );
}
